import _get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';

import { addStyleRule, updateStyleRule, deleteStyleRule } from '../../../../../actions/website';
import { selectStyleRules } from '../../selectors';
import { formatStyleRuleValue } from '../../services/format';

export default function useStyleRule(name) {
  const dispatch = useDispatch();
  const styleRules = useSelector(selectStyleRules);

  const finalName = formatStyleRuleValue(name);

  function getStyleRuleIndex(rules) {
    return rules.findIndex((rule) => rule.name === finalName);
  }

  const initialStyleRuleIndex = getStyleRuleIndex(styleRules);
  const styleRule = initialStyleRuleIndex === -1 ? null : styleRules[initialStyleRuleIndex];
  const value = _get(styleRule, 'value', null);

  function setValue(newValue) {
    const styleRuleIndex = getStyleRuleIndex(styleRules);
    if (styleRuleIndex === -1) {
      dispatch(addStyleRule({ name: finalName, value: newValue }));
    } else {
      dispatch(updateStyleRule({ index: styleRuleIndex, field: 'value', fieldValue: newValue }));
    }
  }

  function deleteRule() {
    const styleRuleIndex = getStyleRuleIndex(styleRules);
    dispatch(deleteStyleRule(styleRuleIndex));
  }

  return { value, styleRule, setValue, deleteRule };
}
